import { button } from '@/constants/system';
import store from '@/store';

export default function(app) {
  app.directive('permission', {
    beforeMount(el, binding, vnode) {
      const appType = store.state.user.userType;
      const buttonPermission = button[appType] || [];
      if (!buttonPermission.includes(binding.value)) el.style.display = 'none';
    }
  })
}